export default "__VITE_ASSET__DX6Ng03A__"